<ng-container *ngIf="job && country">
  <app-checkout-page
    [country]="country"
    [orderData]="job"
    [redirectUrl]="redirectUrl"
    [shouldRedirect]="shouldRedirect"
  ></app-checkout-page>
</ng-container>
